module.exports = __webpack_public_path__ + "img/case_template_icon_blue.84b7914d.svg";